import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtIDR, fmtDate } from "../lib/utils";
import { STATUS_STYLE } from "./PresettleEditor";

const TL = { awb: "AWB", operation: "OPS", finance: "FIN", hutang: "LUNASI" };

// Daftar centang item rincian di form Settle. waiting = pelunasan yg DP-nya belum di-settle.
export default function PresettleChecklist({ panjar, selected, setSelected }) {
  const items = panjar.presettle_items || [];
  const [dpPlans, setDpPlans] = useState(null);
  useEffect(() => { api.get("/cash-advances-dp-plans").then((r) => setDpPlans(r.data || [])).catch(() => setDpPlans([])); }, [panjar.id]);
  if (!items.length) return null;
  const waitingIds = new Set((dpPlans || []).map((d) => d.item_id));
  const isWaiting = (i) => i.target === "hutang" && !i.cost_id && waitingIds.has(i.plan_item_id);
  const plan = items.filter((i) => i.status === "plan");
  const selectable = plan.filter((i) => !isWaiting(i));
  const toggle = (id) => setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  const total = items.filter((i) => selected.includes(i.item_id)).reduce((s, i) => s + i.amount, 0);
  return (
    <div className="border border-sky-200 rounded-lg overflow-hidden" data-testid="presettle-checklist">
      <div className="px-3 py-2 bg-sky-50 flex items-center justify-between">
        <span className="text-[11px] uppercase font-bold text-sky-800">Pilih item dari rincian ({plan.length} rencana)</span>
        <div className="flex items-center gap-3 text-xs">
          {selectable.length > 0 && (
            <button type="button" data-testid="presettle-select-all" onClick={() => setSelected(selected.length === selectable.length ? [] : selectable.map((i) => i.item_id))} className="font-bold text-sky-800 hover:underline">
              {selected.length === selectable.length ? "Batal pilih semua" : "Pilih semua"}
            </button>
          )}
          <span>Dipilih: <b className="font-mono">{fmtIDR(total)}</b></span>
        </div>
      </div>
      <div className="divide-y divide-sky-100 max-h-64 overflow-y-auto">
        {items.map((i) => {
          const waiting = i.status === "plan" && isWaiting(i);
          const done = i.status === "settled";
          return (
            <label key={i.item_id} data-testid={`presettle-check-${i.item_id}`} className={`flex items-center gap-3 px-3 py-2 text-xs ${done || waiting ? "opacity-60" : "cursor-pointer hover:bg-sky-50/50"}`}>
              <input type="checkbox" className="accent-sky-700" disabled={done || waiting} checked={done || selected.includes(i.item_id)} onChange={() => toggle(i.item_id)}/>
              <span className="w-14 font-bold text-slate-600">{TL[i.target]}</span>
              <span className="flex-1">
                {i.target === "hutang" ? i.plan_label : i.target === "awb" ? <><b className="font-mono">{i.awb_number}</b>{i.vendor_name ? ` · ${i.vendor_name}` : ""}</> : i.expense_category || "Operation"}
                {i.description && <span className="text-slate-500"> · {i.description}</span>}
                {i.unpaid_amount > 0 && <span className="text-amber-700"> · sisa hutang {fmtIDR(i.unpaid_amount)}</span>}
              </span>
              <span className="text-slate-500 w-20">{i.transaction_date ? fmtDate(i.transaction_date) : "-"}</span>
              <span className="font-mono font-bold w-28 text-right">{fmtIDR(i.amount)}</span>
              <span className={`text-[9px] font-bold uppercase px-1.5 py-0.5 rounded w-28 text-center ${STATUS_STYLE[done ? "settled" : waiting ? "waiting" : "plan"]}`}>
                {done ? `Settle ${i.settled_at ? fmtDate(i.settled_at) : ""}` : waiting ? "Menunggu DP" : "Rencana"}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
